const UPDATE_MODEL_EVENT = 'update:modelValue';
const CHANGE_EVENT = 'change';
const INPUT_EVENT = 'input';
const VALIDATE_STATE_MAP = {
    validating: 'el-icon-loading',
    success: 'el-icon-circle-check',
    error: 'el-icon-circle-close',
};

export { CHANGE_EVENT, INPUT_EVENT, UPDATE_MODEL_EVENT, VALIDATE_STATE_MAP };
